module.exports = __webpack_public_path__ + "front/img/logo-4.4e9931a4.png";